/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 701);
/******/ })
/************************************************************************/
/******/ ({

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInIframe = exports.isLocalhost = exports.apiDelay = undefined;

var _constants = __webpack_require__(13);

var apiDelay = exports.apiDelay = function apiDelay() {
  return new Promise(function (resolve, reject) {
    if (_constants.DEVELOP_MODE) {
      setTimeout(function () {
        resolve();
      }, _constants.SIMULATE_NETWORK_DELAY_IN_MS);
    } else {
      resolve();
    }
  });
}; /**
    developer-utils
    Created by RuSsCiTy on 20.09.2017
    **/
var isLocalhost = exports.isLocalhost = function isLocalhost() {
  return !(window.location.href.indexOf("localhost") < 0);
};

var isInIframe = exports.isInIframe = function isInIframe() {
  try {
    // for reference: http://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t/326076#326076
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIphoneOrIpod = exports.isMobileBrowser = exports.is32Bit = exports.is64Bit = exports.isWindows = exports.isAndroid = exports.isMac = exports.isIOS = exports.getMajorBrowserVersion = exports.isEdge = exports.isIE12 = exports.isIE11 = exports.isIE = exports.isSafari = exports.isFirefox = exports.isChrome = undefined;
exports.listCookies = listCookies;
exports.isEuUser = isEuUser;

var _uaParserJs = __webpack_require__(161);

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

var _constants = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We can pull data once because browser doesn't change while runtime
/**

 About ua-parser-js:

 getBrowser()
 returns { name: '', version: '' }

 # Possible 'browser.name':
 Amaya, Android Browser, Arora, Avant, Baidu, Blazer, Bolt, Bowser, Camino, Chimera,
 Chrome [WebView], Chromium, Comodo Dragon, Conkeror, Dillo, Dolphin, Doris, Edge,
 Epiphany, Fennec, Firebird, Firefox, Flock, GoBrowser, iCab, ICE Browser, IceApe,
 IceCat, IceDragon, Iceweasel, IE[Mobile], Iron, Jasmine, K-Meleon, Konqueror, Kindle,
 Links, Lunascape, Lynx, Maemo, Maxthon, Midori, Minimo, MIUI Browser, [Mobile] Safari,
 Mosaic, Mozilla, Netfront, Netscape, NetSurf, Nokia, OmniWeb, Opera [Mini/Mobi/Tablet],
 PhantomJS, Phoenix, Polaris, QQBrowser, RockMelt, Silk, Skyfire, SeaMonkey, Sleipnir,
 SlimBrowser, Swiftfox, Tizen, UCBrowser, Vivaldi, w3m, WeChat, Yandex
 ===========

 getDevice()
 returns { model: '', type: '', vendor: '' }

 # Possible 'device.type':
 console, mobile, tablet, smarttv, wearable, embedded
 ===========

 getOS()
 returns { name: '', version: '' }

 # Possible 'os.name'
 AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, CentOS, Chromium OS, Contiki,
 Fedora, Firefox OS, FreeBSD, Debian, DragonFly, Gentoo, GNU, Haiku, Hurd, iOS,
 Joli, Linpus, Linux, Mac OS, Mageia, Mandriva, MeeGo, Minix, Mint, Morph OS, NetBSD,
 Nintendo, OpenBSD, OpenVMS, OS/2, Palm, PC-BSD, PCLinuxOS, Plan9, Playstation, QNX, RedHat,
 RIM Tablet OS, RISC OS, Sailfish, Series40, Slackware, Solaris, SUSE, Symbian, Tizen,
 Ubuntu, UNIX, VectorLinux, WebOS, Windows [Phone/Mobile], Zenwalk

 More info at https://www.npmjs.com/package/ua-parser-js
 */
var uAParser = new _uaParserJs2.default();
var browser = uAParser.getBrowser();
var os = uAParser.getOS();
var cpu = uAParser.getCPU();
var device = uAParser.getDevice();

var AMD64 = "amd64";
var WIN11 = 11;
var WIN12 = 12;

function contains(stringA, stringB) {
  console.log("stringA", stringA);
  console.log("stringB", stringB);
  console.log("res", stringA.toLowerCase().indexOf(stringB.toLowerCase()));
  if (stringA && stringA.length && stringB) {
    return stringA.toLowerCase().indexOf(stringB.toLowerCase()) !== -1;
  }
}

/**
 * BROWSER
 */

var isChrome = exports.isChrome = function isChrome() {
  return contains(browser.name, _constants.BROWSER.CHROME);
};
var isFirefox = exports.isFirefox = function isFirefox() {
  return contains(browser.name, _constants.BROWSER.FIREFOX);
};
var isSafari = exports.isSafari = function isSafari() {
  return contains(browser.name, _constants.BROWSER.SAFARI);
};

var isIE = exports.isIE = function isIE() {
  return contains(browser.name, _constants.BROWSER.IE);
};
var isIE11 = exports.isIE11 = function isIE11() {
  return isIE() && parseInt(browser.major) === WIN11;
};
var isIE12 = exports.isIE12 = function isIE12() {
  return isIE() && parseInt(browser.major) === WIN12;
};

var isEdge = exports.isEdge = function isEdge() {
  return contains(browser.name, _constants.BROWSER.EDGE);
};

var getMajorBrowserVersion = exports.getMajorBrowserVersion = function getMajorBrowserVersion() {
  return parseInt(browser.major);
};

/**
 * OPERATING SYSTEMS
 */

var isIOS = exports.isIOS = function isIOS() {
  return contains(os.name, _constants.OS.IOS);
};
var isMac = exports.isMac = function isMac() {
  return contains(os.name, _constants.OS.MAC);
};
var isAndroid = exports.isAndroid = function isAndroid() {
  return contains(os.name, _constants.OS.ANDROID);
};
var isWindows = exports.isWindows = function isWindows() {
  return contains(os.name, _constants.OS.WIN);
};

var is64Bit = exports.is64Bit = function is64Bit() {
  return cpu.architecture === AMD64;
};
var is32Bit = exports.is32Bit = function is32Bit() {
  return !is64Bit();
};

/**
 * DEVICE
 */

var isMobileBrowser = exports.isMobileBrowser = function isMobileBrowser() {
  return contains(device.type, "mobile") || contains(device.type, "tablet");
};
var isIphoneOrIpod = exports.isIphoneOrIpod = function isIphoneOrIpod() {
  return contains(navigator.userAgent, "iphone") || contains(navigator.userAgent, "ipod");
};

function listCookies() {
  var cookiesArray = document.cookie.split(";");
  var result = [];
  for (var i = 0; i < cookiesArray.length; i++) {
    var pairCookie = cookiesArray[i].split("=");
    if (pairCookie[0] && pairCookie[1]) {
      result.push({ name: pairCookie[0].trim(), value: pairCookie[1].trim() });
    }
  }
  return result;
}

function isEuUser(code) {
  var euCountries = {
    BE: "Belgium",
    EL: "Greece",
    LT: "Lithuania",
    PT: "Portugal",
    BG: "Bulgaria",
    ES: "Spain",
    LU: "Luxembourg",
    RO: "Romania",
    CZ: "Czech Republic",
    FR: "France",
    HU: "Hungary",
    SI: "Slovenia",
    DK: "Denmark",
    HR: "Croatia",
    MT: "Malta",
    SK: "Slovakia",
    DE: "Germany",
    IT: "Italy",
    NL: "Netherlands",
    FI: "Finland",
    EE: "Estonia",
    CY: "Cyprus",
    AT: "Austria",
    SE: "Sweden",
    IE: "Ireland",
    LV: "Latvia",
    PL: "Poland",
    UK: "United Kingdom"
  };
  return !!euCountries[code];
}

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localStorageSupport = localStorageSupport;
exports.setItem = setItem;
exports.getItem = getItem;
exports.removeItem = removeItem;
/**
 * Created by DRaco2 on 03.03.2017.
 */

function localStorageSupport() {
  try {
    if ("localStorage" in window && window["localStorage"] !== null) {
      try {
        localStorage.setItem("test", "test");
        localStorage.removeItem("test");
        return true;
      } catch (e) {
        console.error("localStorage not supported/quota exceeded.", e);
        return false;
      }
    }
  } catch (err) {
    console.warn(err);
    return false;
  }
}

function setItem(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  if (localStorageSupport()) {
    localStorage.setItem(name, value);
  } else {
    document.cookie = name + "=" + value + expires + "; path=/";
  }
}
function getItem(name) {
  if (localStorageSupport()) {
    var ret = localStorage.getItem(name);
    //console.log(typeof ret);
    switch (ret) {
      case "true":
        return true;
      case "false":
        return false;
      default:
        return ret;
    }
  } else {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) == 0) {
        var _ret = c.substring(nameEQ.length, c.length);
        switch (_ret) {
          case "true":
            return true;
          case "false":
            return false;
          default:
            return _ret;
        }
      }
    }
    return null;
  }
}

function removeItem(name) {
  if (localStorageSupport()) {
    localStorage.removeItem(name);
  } else {
    setItem(name, "", -1);
  }
}

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 constants
 Created by RuSsCiTy on 07.05.2018
 **/

/** DEVELOPER CONSTANTS */
var DEVELOP_MODE = exports.DEVELOP_MODE = false;
var SIMULATE_NETWORK_DELAY_IN_MS = exports.SIMULATE_NETWORK_DELAY_IN_MS = 300;

var BROWSER = exports.BROWSER = {
  SUPPORTED_VERSION_MIN: {
    FIREFOX: 30,
    CHROME: 31
  },
  CHROME: "CHROME",
  FIREFOX: "FIREFOX",
  SAFARI: "SAFARI",
  IE: "IE",
  EDGE: "EDGE"
};

var OS = exports.OS = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  MAC: "MAC",
  WIN: "WIN"
};

/**
 * Constant for page selecting
 * @type {{loading: string, login: string, register: string, pwrecovery: string}}
 */
var PAGES = exports.PAGES = {
  intro: "intro",
  accept_cookie: "accept_cookie",
  details: "details",
  bottom_info: "bottom_info"
};

/**
 * Constant to represent user state
 * @type {{logged_in: string, not_logged_in: string}}
 */
var USER_STATE = exports.USER_STATE = {
  logged_in_new: "logged_in_new",
  logged_in_exist: "logged_in_exist",
  not_logged_in: "not_logged_in"
};
/**
 *
 * @type {{}}
 */
var COMPANY_ROLE = exports.COMPANY_ROLE = {
  COMPANY_EXECUTIVE: "COMPANY_EXECUTIVE",
  COMPANY_VIEWER: "COMPANY_VIEWER",
  COMPANY_ADMIN: "COMPANY_ADMIN",
  COMPANY_MANAGER: "COMPANY_MANAGER",
  PROJECT_MANAGER: "PROJECT_MANAGER",
  COMPANY_MEMBER: "COMPANY_MEMBER"
};

/**
 * Constant to represent server code answers
 * @type {{CODE_USER_EMAIL_UNKNOWN: string, CODE_USER_CREDENTIALS_INCORRECT: string, OAUTH_SUCCESS_USER_NEW: string, OAUTH_SUCCESS_USER_EXIST: string, OAUTH_ERROR_USER_EXIST_WITH_OTHER_PROVIDER: string}}
 */
var SERVER_CONST = exports.SERVER_CONST = {
  CODE_USER_EMAIL_UNKNOWN: "userEmailUnknown",
  CODE_USER_CREDENTIALS_INCORRECT: "userCredentialsIncorrect",
  CODE_USER_EMAIL_NOT_VERIFIED: "userEmailNotVerified",

  // OAUTH
  OAUTH_SUCCESS_USER_NEW: "OAUTH_SUCCESS_USER_NEW",
  OAUTH_SUCCESS_USER_EXIST: "OAUTH_SUCCESS_USER_EXIST",
  OAUTH_ERROR_USER_EXIST_WITH_OTHER_PROVIDER: "OAUTH_ERROR_USER_EXIST_WITH_OTHER_PROVIDER"
};

/**
 * Constant to represent actual native app versions
 * @type {{ANDROID_VER: string, IOS_VER: string}}
 */
var APP_VERSIONS = exports.APP_VERSIONS = {
  ANDROID_VER: "1.5.9",
  IOS_VER: "1.5.6"
};

var APP_TYPES = exports.APP_TYPES = {
  andr: "andr",
  ios: "ios",
  web: "web"
};

/** REGEX */
var EMAIL_REG_EX = exports.EMAIL_REG_EX = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var prefix = "";

var COOKIE_PREFERENCES = exports.COOKIE_PREFERENCES = {
  COOKIE_ACCEPTED: "COOKIE_ACCEPTED",
  COOKIE_SETTINGS: "COOKIE_SETTINGS"
};

var OPTOUT_URLS = exports.OPTOUT_URLS = {
  SALESFORCE: "https://consumer.krxd.net/consumer/optout?verify=true"
};
var OPTIN_URLS = exports.OPTIN_URLS = {
  SALESFORCE: "https://consumer.krxd.net/consumer/optin?verify=true"
};

var ANALYTICS_IDS = exports.ANALYTICS_IDS = ["UA-48533890-1", // movemygps web
"UA-48533890-2", // alltracker web
"UA-48533890-3" // russ.city web
];

var URL_TO_COOKIE_PRIVACY = exports.URL_TO_COOKIE_PRIVACY = "https://alltracker.org/cookies";

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.31
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.31',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 255;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK   = 'Facebook';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /\bqbcore\/([\w\.]+)/i                                              // WeChat Desktop for Windows Built-in Browser
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i                                                      // LieBao Browser
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i                        // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w\.]+) .*(mobile ?safari|safari)/i                     // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2)?)/i                                                     // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i              // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86)/i                              // Android-x86
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(162)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 162:
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by RUSS_ on 07.05.2018
 *
 * Note: don't change id's of cookies because these are used as keys
 */

exports.default = {
  generate: function generate() {
    var config = {
      necessary: {
        name: myTranslation("necessary") + " Cookies",
        description: myTranslation("necessary_desc"),
        list: [{
          id: "russcity_necessary",
          name: "RuSsCiTy",
          description: "The personal site of Ruslan Ragimov. This cookies may store your settings about cookies",
          usage: {
            en: "The personal site of Ruslan Ragimov. This cookies may store your settings about cookies.",
            de: "Die persönliche Seite von Ruslan Ragimov. Diese Cookies können Ihre Einstellungen zu Cookies speichern.",
            ru: "Персональный сайт Руслана Рагимова. Эти файлы cookie могут сохранять ваши настройки в отношении файлов cookie."
          },
          domains: ["russ.city", "russcity.de"],
          privacy: "https://alltracker.org/index.jsp?page=privacy",
          terms: "https://alltracker.org/index.jsp?page=lizens_agree",
          accepted: true,
          immutable: true
        }, {
          id: "alltracker_necessary",
          name: "AllTracker",
          description: "Best way to monitor your Android device. Protect Yourself and Your Family! This cookies stores your personal preferences, manages your secure login to the web page.",
          usage: {
            en: "Best way to monitor your Android device. Protect Yourself and Your Family! This cookies stores your personal preferences, manages your secure login to the web page.",
            de: "Beste Möglichkeit, Ihr Android-Gerät zu überwachen. Beschütze dich und deine Familie! Dieser Cookie speichert Ihre persönlichen Einstellungen und verwaltet Ihre sichere Anmeldung auf der Webseite.",
            ru: "Лучший способ контролировать ваше Android-устройство. Защитите себя и свою семью! Это файлы Cookie сохраняют ваши личные предпочтения, управляет вашим безопасным входом на веб-страницу."
          },
          domains: ["alltracker.org", "alltracker.de", "alltracker.su"],
          privacy: "https://alltracker.org/index.jsp?page=privacy",
          terms: "https://alltracker.org/index.jsp?page=lizens_agree",
          accepted: true,
          immutable: true
        }]
      },
      preferences: {
        name: myTranslation("preferences") + " Cookies",
        description: myTranslation("preferences_desc"),
        list: [{
          id: "facebook_like",
          name: "Facebook Like",
          description: "Facebook is an American online social media and social networking service company based in Menlo Park, California. This cookie makes it possible to share your experience with the world by Facebook!",
          usage: {
            en: "Facebook is an American online social media and social networking service company based in Menlo Park, California. This cookie makes it possible to share your experience with the world by Facebook!",
            de: "Facebook ist ein amerikanisches Online-Social-Media- und Social-Networking-Unternehmen mit Sitz in Menlo Park, Kalifornien. Dieser Cookie ermöglicht es, Ihre Erfahrungen mit der Welt über Facebook zu teilen!",
            ru: "Facebook - американская социальная сеть, основанная в Менло-Парке, штат Калифорния. Этот Cookie-файл позволяет поделиться своим опытом с миром через Facebook!"
          },
          domains: ["facebook.com"],
          privacy: "https://www.facebook.com/legal/FB_Work_Privacy",
          terms: "https://www.facebook.com/terms.php",
          accepted: false,
          immutable: false
        }, {
          id: "vk_com",
          name: "VK.com",
          description: "VK is a Russian online social media and social networking service. It is available in several languages but it is especially popular among Russian-speaking users. This cookie makes it possible to share your experience with the world by VK!",
          usage: {
            en: "VK is a Russian online social media and social networking service. It is available in several languages but it is especially popular among Russian-speaking users. This cookie makes it possible to share your experience with the world by VK!",
            de: "VK ist ein russischer Online-Social-Media- und Social-Networking-Service. Es ist in mehreren Sprachen verfügbar, ist aber besonders bei russischsprachigen Benutzern beliebt. Dieser Cookie ermöglicht es, Ihre Erfahrungen mit der Welt über VK zu teilen!",
            ru: "VK - это русская онлайн-социальная сеть. Она доступена на нескольких языках, но особенно популярена среди русскоязычных пользователей. Этот Cookie-файл позволяет поделиться своим опытом с миром через VK!"
          },
          domains: ["vk.com", "vk.ru"],
          privacy: "https://vk.com/privacy/",
          terms: "https://vk.com/terms/",
          accepted: false,
          immutable: false
        }]
      },
      statistics: {
        name: myTranslation("statistics") + " Cookies",
        description: myTranslation("statistics_desc"),
        list: [{
          id: "google_analytics",
          name: "Google Analytics",
          description: "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Analytics cookies are used to collect some useful statistics about user experience on our web page.",
          usage: {
            en: "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Analytics cookies are used to collect some useful statistics about user experience on our web page.",
            de: "Google (www.google.com) betreibt das Google Display-Netzwerk eine Sammlung von Millionen von Websites und mobilen Anwendungen, die auf Display-Werbung basieren, darunter viele Google-Dienste wie YouTube. Analytics-Cookies werden verwendet, um einige nützliche Statistiken über die Nutzererfahrung auf unserer Webseite zu sammeln.",
            ru: "Google (www.google.com) управляет контекстно-медийной сетью Google, собрав миллионы веб-сайтов и мобильных приложений, которые работают на медийной рекламе, включая многие сервисы Google, такие как YouTube. Файлы cookie от Google Analytics используются для сбора полезной статистики о пользовательском опыте на нашей веб-странице."
          },
          domains: ["google.com", "google.de"],
          privacy: "http://www.google.com/intl/en/policies/privacy/",
          terms: "https://www.google.com/intl/en/policies/terms/",
          accepted: false,
          immutable: false
        }, {
          id: "yandex_metrica",
          name: "Yandex Metrica",
          description: "From traffic trends to mouse movements – Yandex helps to get a comprehensive understanding of online audience and drive business growth. Cookies of Yandex Metrica are used to collect some useful statistics about user experience on our web page.",
          usage: {
            en: "From traffic trends to mouse movements – Yandex helps to get a comprehensive understanding of online audience and drive business growth. Cookies of Yandex Metrica are used to collect some useful statistics about user experience on our web page.",
            de: "Von Verkehrstrends bis hin zu Mausbewegungen - Yandex hilft, ein umfassendes Verständnis der Online-Zielgruppe zu erlangen und das Geschäftswachstum anzukurbeln. Cookies von Yandex Metrica werden verwendet, um nützliche Statistiken über die Benutzererfahrung auf unserer Webseite zu sammeln.",
            ru: "От тенденций движения до движений мыши - Yandex помогает получить полное представление о онлайн-аудитории и стимулировать рост бизнеса. Cookie-файлы Yandex Metrica используются для сбора полезной статистики о пользовательском опыте на нашей веб-странице."
          },
          domains: ["yandex.ru", "metrica.yandex.ru", "mc.yandex.ru"],
          privacy: "https://metrica.yandex.com/about/info/privacy-policy/",
          terms: "https://yandex.com/legal/metrica_termsofuse/",
          accepted: false,
          immutable: false
        }]
      },
      marketing: {
        name: myTranslation("marketing") + " Cookies",
        description: myTranslation("marketing_desc"),
        list: [{
          id: "google_adsense",
          name: "Google Adsense.",
          description: "Google AdSense is a program run by Google that allows publishers in the Google Network of content sites to serve automatic text, image, video, or interactive media advertisements, that are targeted to site content and audience.",
          usage: {
            en: "Google AdSense is a program run by Google that allows publishers in the Google Network of content sites to serve automatic text, image, video, or interactive media advertisements, that are targeted to site content and audience.",
            de: "Google AdSense ist ein von Google betriebenes Programm, mit dem Publisher im Google-Werbenetzwerk von Content-Websites automatische Text-, Bild-, Video- oder interaktive Medienanzeigen schalten können, die auf Website-Content und Zielgruppe ausgerichtet sind.",
            ru: "Google AdSense - это программа от Google, которая позволяет издателям в сети контекстно-медийной сети Google обслуживать автоматические текстовые, графические, видео или интерактивные медиа-рекламы, предназначенные для контента и аудитории сайта."
          },
          domains: ["google.de", "google.com", "google.de", "googlesyndication.com", "googleads.g.doubleclick.net", "tpc.googlesyndication.com"],
          privacy: "https://policies.google.com/privacy",
          terms: "https://www.google.com/adsense/new/localized-terms",
          accepted: false,
          immutable: false
        }, {
          id: "youtube",
          name: "Youtube",
          description: "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Youtube cookies are used to get better experience on targeting ads to the user's interests based on the information that the cookie collected.",
          usage: {
            en: "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Youtube cookies are used to get better experience on targeting ads to the user's interests based on the information that the cookie collected.",
            de: "Google (www.google.com) betreibt das Google Display-Netzwerk eine Sammlung von Millionen von Websites und mobilen Anwendungen, die auf Display-Werbung basieren, darunter viele Google-Dienste wie YouTube. Youtube-Cookies werden verwendet, um bessere Ergebnisse beim Targeting von Anzeigen auf die Interessen des Nutzers zu erzielen, basierend auf den Informationen, die der Cookie gesammelt hat.",
            ru: "Google (www.google.com) управляет контекстно-медийной сетью Google, собрав миллионы веб-сайтов и мобильных приложений, которые работают на медийной рекламе, включая многие сервисы Google, такие как YouTube. Cookie файды Youtube используются для получения лучшего опыта по таргетингу объявлений в интересах пользователя на основе информации, собранной cookie."
          },
          domains: ["www.youtube.com", "youtube.com"],
          privacy: "http://www.google.com/intl/en/policies/privacy/",
          terms: "https://www.google.com/intl/en/policies/terms/",
          accepted: false,
          immutable: false
        }]
      }
    };
    return config;
  }
};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitForBrowserInfo = waitForBrowserInfo;

var _browser = __webpack_require__(172);

window.mLastBrowserInfo = window.mLastBrowserInfo || null; /**
                                                            * Created by RUSS_ on 18.09.2018
                                                            */

window.firstBrowserRequestStarted = window.firstBrowserRequestStarted || false;
window.browserInfoResolves = window.browserInfoResolves || [];
function waitForBrowserInfo() {
  return new Promise(function (res, rej) {
    if (window.mLastBrowserInfo) {
      res(window.mLastBrowserInfo);
    } else if (window.firstBrowserRequestStarted) {
      window.browserInfoResolves.push(res);
    } else {
      window.firstBrowserRequestStarted = true;
      (0, _browser.getBrowserInfo)().then(function (answer) {
        window.mLastBrowserInfo = answer;
        for (var i = 0; i < window.browserInfoResolves.length; i++) {
          window.browserInfoResolves[i](window.mLastBrowserInfo);
        }
        res(answer);
      });
    }
  });
}

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserInfo = getBrowserInfo;

var _developerUtils = __webpack_require__(108);

var USER_API_ROOT = "https://alltracker.org/v1/browser"; /**
                                                          * Created by RUSS_ on 16.05.2018
                                                          */

var lastBrowserAnswer = null;

function getBrowserInfo() {
  return new Promise(function (resolve, reject) {
    // resolve({ data: { country: "RU", language: "ru" } });
    // return;
    if (!lastBrowserAnswer) {
      (0, _developerUtils.apiDelay)().then(function () {
        $.ajax({
          dataType: "json",
          url: USER_API_ROOT + "/info",
          type: "GET",
          crossDomain: true,
          success: function success(answer) {
            if (!answer.data.language) {
              // default language en
              answer.data.language = "en";
            }
            if (!answer.data.country) {
              // show always this dialog
              answer.data.country = "DE";
            }
            lastBrowserAnswer = answer;
            resolve(answer);
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            resolve({ data: { country: "DE", language: "ru" } });
            // reject(jqXHR);
          }
        });
      });
    } else {
      // we don't need to ask server each time about browser info. One time pro session is enough
      resolve(lastBrowserAnswer);
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _localStorageUtil = __webpack_require__(110);

var _constants = __webpack_require__(13);

var _apiManager = __webpack_require__(86);

var _cookieConfigHelper = __webpack_require__(73);

var _defaultCookiesConfig = __webpack_require__(163);

var _defaultCookiesConfig2 = _interopRequireDefault(_defaultCookiesConfig);

var _browser = __webpack_require__(109);

var _browserManager = __webpack_require__(171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookieAccepted = (0, _localStorageUtil.getItem)(_constants.COOKIE_PREFERENCES.COOKIE_ACCEPTED); /**
                                                                                                     * Created by RUSS_ on 15.05.2018
                                                                                                     */

var cookieSettings = JSON.parse((0, _localStorageUtil.getItem)(_constants.COOKIE_PREFERENCES.COOKIE_SETTINGS));

console.log("Prefly RuSs.CiTy Cookie Manager Initialized", cookieSettings);
window.myTranslation = function () {
  return "";
};
_apiManager.api.isCookieAccepted = function (id) {
  return new Promise(function (resolve, reject) {
    (0, _browserManager.waitForBrowserInfo)().then(function (answer) {
      if ((0, _browser.isEuUser)(answer.data.country) || true) {
        resolve(cookieAccepted && cookieSettings && (0, _cookieConfigHelper.getCookieById)(cookieSettings, id) && (0, _cookieConfigHelper.getCookieById)(cookieSettings, id).accepted);
      } else {
        resolve(!cookieAccepted || cookieSettings && (0, _cookieConfigHelper.getCookieById)(cookieSettings, id) && (0, _cookieConfigHelper.getCookieById)(cookieSettings, id).accepted);
      }
    });
  });
};

_apiManager.api.getHtmlToAcceptCookie = function (id) {
  var defaultConfig = _defaultCookiesConfig2.default.generate();
  var asArray = (0, _cookieConfigHelper.getConfigAsArrayJson)(defaultConfig);
  var cookie = (0, _cookieConfigHelper.getCookieById)(asArray, id);
  return "<div style=\"text-align: center;\"><div style=\"color: orangered;\">You can see this area if you accept cookie: <b style=\"color: red; font-weight: bolder;\">" + cookie.name + "</b></div><button class=\"btn btn-primary\" onclick=\"RussCityCookieManager.showAcceptCookieDialog({'cookieId':'" + id + "'})\">Accept Selected</button></div>";
};

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAtLeatOneCookiesOfListAccepted = isAtLeatOneCookiesOfListAccepted;
exports.allCookiesOfListAccepted = allCookiesOfListAccepted;
exports.getCurrentConfigAsJsonFromList = getCurrentConfigAsJsonFromList;
exports.getCookieById = getCookieById;
exports.proveOneCategory = proveOneCategory;
exports.toggleCategory = toggleCategory;
exports.convertToConfigFromStorage = convertToConfigFromStorage;
exports.clone = clone;
exports.getConfigAsArrayJson = getConfigAsArrayJson;
/**
 * Created by RUSS_ on 08.05.2018
 */
function isAtLeatOneCookiesOfListAccepted(list) {
  for (var i = 0; i < list.length; i++) {
    if (list[i].accepted) {
      return true;
    }
  }
  return false;
}

function allCookiesOfListAccepted(list) {
  for (var i = 0; i < list.length; i++) {
    if (!list[i].accepted) {
      return false;
    }
  }
  return true;
}

function getCurrentConfigAsJsonFromList(list) {
  var result = [];
  for (var i = 0; i < list.length; i++) {
    result.push(list[i]);
    //   name: list[i].name,
    //   id: list[i].id,
    //   accepted: list[i].accepted,
    //   domains: list[i].domains,
    //   immutable: list[i].immutable
    // });
  }
  return result;
}

function getCookieById(settingsArray, id) {
  for (var i = 0; i < settingsArray.length; i++) {
    if (settingsArray[i].id === id) {
      return settingsArray[i];
    }
  }
  return null;
}

function proveOneCategory(settingsJson, list) {
  for (var i = 0; i < list.length; i++) {
    for (var j = 0; j < settingsJson.length; j++) {
      if (settingsJson[j].id === list[i].id) {
        list[i].accepted = settingsJson[j].accepted;
      }
    }
  }
  return list;
}

function toggleCategory(category, enabled) {
  for (var i = 0; i < category.list.length; i++) {
    category.list[i].accepted = enabled;
  }
  return category;
}

function convertToConfigFromStorage(settingsText, CookieConfig) {
  var settingsJson = JSON.parse(settingsText);
  CookieConfig.necessary.list = proveOneCategory(settingsJson, CookieConfig.necessary.list);
  CookieConfig.preferences.list = proveOneCategory(settingsJson, CookieConfig.preferences.list);
  CookieConfig.statistics.list = proveOneCategory(settingsJson, CookieConfig.statistics.list);
  CookieConfig.marketing.list = proveOneCategory(settingsJson, CookieConfig.marketing.list);
  return CookieConfig;
}

function clone(object) {
  return JSON.parse(JSON.stringify(object));
}

function getConfigAsArrayJson(config) {
  var result = [];
  result = result.concat(getCurrentConfigAsJsonFromList(config.necessary.list));
  result = result.concat(getCurrentConfigAsJsonFromList(config.preferences.list));
  result = result.concat(getCurrentConfigAsJsonFromList(config.statistics.list));
  result = result.concat(getCurrentConfigAsJsonFromList(config.marketing.list));
  return clone(result);
}

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by RUSS_ on 15.05.2018
 */
var api = exports.api = {
  /**
   * function with these options = {
        preferencesButton: true,
        preferencesButtonPosition: "bottom left"
     }
     will be @override
   */
  init: null,
  /**
   * a wrapper to avoid incompatibility problems
   */
  dispatch: function dispatch(fnct) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (typeof undefined[fnct] === "function") {
      undefined[fnct](args);
    }
  },

  /**
   * checks whether a certain cookie is accepted, by its id
   * will be @override
   */
  isCookieAccepted: null
};

// provide api in global scope. Don't override it, if already exist from prefly script
if (window.RussCityCookieManager) {
  exports.api = api = Object.create(window.RussCityCookieManager);
}
window.RussCityCookieManager = api;

/***/ })

/******/ });


// WEBPACK FOOTER //
// cookie_prefly_v.1.8_bundle.js